import { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

import pdfLogo from '../assets/pdf.png'
import '../styles/Dropzone.css';

const MyDropzone = ({ file, setFile }) => {
  const [borderColor, setBorderColor] = useState(`var(--Header-color)`);
  const [isHovered, setIsHovered] = useState(false);
  const [errorUpload, setErrorUpload] = useState(false);

  useEffect(() => {
    if (file != null) {
      setBorderColor(`var(--Header-color)`)
    }
  }, [file]);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    setIsHovered(false);

    if (fileRejections.length !== 0) {
      setBorderColor(`var(--Error-color)`);
      setErrorUpload(true);
      setFile(null);
    } else if (acceptedFiles.length !== 0) {
      setBorderColor(`var(--Success-color)`);
      setErrorUpload(false);

      acceptedFiles.forEach((currFile) => {
        const reader = new FileReader();
        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        reader.onload = () => {
          setFile(currFile);
        };
        reader.readAsArrayBuffer(currFile);
      });
    }

  }, [setFile]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'] },
    maxFiles: 1,
    onDragEnter: () => setBorderColor(`var(--Process-color)`),
    onDragLeave: () => setBorderColor(errorUpload ? `var(--Error-color)` : `var(--Header-color)`),
    disabled: (file != null && !errorUpload)
  });

  return (
    <div className='myDropzone' style={ {border: (file != null && !errorUpload) ? `4px solid var(--Success-color)` : `4px dashed ${isHovered ? `var(--Process-color)` : borderColor}`, cursor: (file != null && !errorUpload) ? `default` : `pointer` } }
      {...getRootProps()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <input {...getInputProps()} />

      { file != null ? (
        // Si hay archivo
        <div className="dropzoneText">
          { errorUpload ? (
            //Si hay archivo pero marcó error
            <div className='dropzoneText dropzoneTextError'>
            </div>
          ) : (
            // Si hay archivo y no hay error
            <div className='errorContainer'>
              <div className='imgContainer'>
                <img src={pdfLogo} className='img' alt="PDF Logo" />
              </div>

              <div className='nameContainer'>
                <div className='name' >{file.name}</div>
              </div>


              <div className="closeButotnDiv">
                <button
                  onClick={() => setFile(null)} 
                  className="closeButotn"
                >
                  X
                </button>
              </div>

            </div>

          )}
        </div>

      ) : (

        // No hay archivo 
        <div className="dropzoneText">
          { errorUpload ? (
            //No hay archivo y se intentó cargar uno con error
            <div className='dropzoneText dropzoneTextError'>
              <div className='error'>Formato inválido</div>
              <div className='dropzoneText dropzoneTextWrap'>
                <div>Seleccione solo un archivo en formato&nbsp;</div>
                <div className='error'>PDF</div>
              </div>
            </div>
          ) : (
            //No hay archivo y no se ha cargado nada
            <div className='dropzoneText dropzoneTextWrap'>
              <div>Arrastre y suelte un archivo</div>
              <div className='error'>&nbsp;PDF&nbsp;</div>
              <div>aquí, o haga clic para seleccionar uno.</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MyDropzone;
